/**
 * The element ids the Invention page's controls carry, so the card that draws
 * one and the footer that jumps to it agree on the spelling.
 */

/** The card of one element of the invention. */
export function elementCardId(elementId: string): string {
  return `element-${elementId}`;
}
